import React, {useCallback, useContext} from 'react';
import {FaBold, FaItalic, FaStrikethrough, FaUnderline} from "react-icons/fa";
import {EditorContext, useEditorState} from "@tiptap/react";

const actionIcons = {
    bold: FaBold,
    italic: FaItalic,
    underline: FaUnderline,
    strike: FaStrikethrough
}

const actionsTitle = {
    bold: "Negrito (Ctrl+B)",
    italic: "Itálico (Ctrl+I)",
    underline: "Sublinhar (Ctrl+U)",
    strike: "Tachado (Ctrl+Shift+S)",
}

const RichTextActionButton = ({type}) => {
    const {editor} = useContext(EditorContext);

    if (!editor || !editor.isEditable) return null;

    return <RichTextActionButtonContent editor={editor} type={type}/>;
};

const RichTextActionButtonContent = ({editor, type}) => {
    const isActive = useEditorState({
        editor,
        selector: ({editor}) => !!editor?.isActive(type),
    });

    const handleClick = useCallback(
        (e) => {
            e.preventDefault();
            if (!editor || editor.isDestroyed) return;
            editor.chain().focus().toggleMark(type).run();
        },
        [editor, type]
    );

    const Icon = actionIcons[type];
    if (!Icon) return null;

    return (
        <button
            type="button"
            className={"rich-text-button" + (isActive ? " active" : "")}
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleClick}
            title={actionsTitle[type]}
        >
            <Icon className="rich-text-button-icon"/>
        </button>
    );
};

export default RichTextActionButton;
